import { Navigate, useLocation, useParams } from 'react-router-dom';

export function RedirectToFilePreview() {
  const location = useLocation();
  const search = location.search;
  return <Navigate to={`preview${search}`} replace />;
}

export function RedirectToAllTab() {
  const location = useLocation();
  const search = location.search;
  return <Navigate to={`all${search}`} replace />;
}

/** The legacy singular `/project/:projectId/*` links: open the project, which lands on its first tab. */
export function RedirectToProject() {
  const { projectId } = useParams<{ projectId: string }>();
  return <Navigate to={`/projects/${projectId}`} replace />;
}
